<div class="navigation">
    <app-layout-navigation>
        <!-- Se pueden agregar breadcrumbs o un titulo general para la pagina aqui -->
        <router-outlet></router-outlet>
    </app-layout-navigation>
</div>